import paths from '@app/src/wf-constants/paths'

// TODO: Add constants instead of strings when pascal/lowercase situation is more stable in the backend
export const pathToRedirect = (solution: string): string => {
  switch (solution?.toLowerCase()) {
    case 'transparency':
      return paths.transparencyDashboard
    case 'sourcing':
      return paths.sourcingDashboard
    case 'investing':
      return paths.investmentDashboard
    case 'finance':
      return paths.financeDashboard
    default:
      return paths.configurations
  }
}

const isSolutionSelectorPath = (path: string): boolean =>
  path === paths.solutionSelector || path.startsWith(`${paths.solutionSelector}?`)

// A redirectTo pointing back at the solution selector (e.g. "/?referral=ABC") would leave the
// user on the page they just logged in from, as if nothing happened.
export const resolvePostLoginPath = (redirectTo: string | null, solution: string): string =>
  redirectTo && !isSolutionSelectorPath(redirectTo) ? redirectTo : pathToRedirect(solution)
